// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"_1Gg0H","cardTitle":"_3-03-","cardSubtitle":"_3QL3f","cardItem":"_1koxA","cardItemCover":"_2dfSj","cardItemTitle":"_3CWhE","cardItemValue":"_2mTTC"};